module.exports = {"430681101":"汨罗镇","430681102":"新市镇","430681103":"古培镇","430681104":"白水镇","430681105":"川山坪镇","430681107":"弼时镇","430681110":"长乐镇","430681111":"大荆镇","430681112":"桃林寺镇","430681113":"三江镇","430681118":"屈子祠镇","430681119":"归义镇","430681120":"神鼎山镇","430681121":"罗江镇","430681122":"白塘镇","430681403":"营田"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430681.json
// module id = 1993
// module chunks = 0